<template>
    <div class="student-learn" @mousemove="move()">

        <!-- 题目弹窗-->
        <Modal ref="modal" v-model="questionVideoModal" title="测评题" :closable="false" :mask-closable="false" footer-hide class="preview-modal" @on-visible-change="colseModal">
            <!-- 题型 -->
            <div class="question-stem-preview">
                <span class="question-stem-content-preview">{{ baseTypeLabel }}</span>
                <span v-if="this.learnRecord.isPass == true" class="pass">回答正确！</span>
                <span v-else-if="this.learnRecord.isPass == false" class="fail">回答错误！</span>
            </div>
            <!-- 题干 -->
            <div class="question-stem-preview">
                <span v-if="question.snLabel" class="sn-label-preview">{{ question.snLabel }}</span>
                <span class="question-stem-content-preview" v-html="question.questionStem"/>
            </div>
            <!-- 选项 1: 单选题和多选题 -->
            <div class="question-options">
                <div v-for="(option, index) in question.optionList" :key="index" :class="{ correct: option.checked }" class="question-option">
                    <div :class="{ correct: option.checked }" class="mark" @click="chooiceAnswer(question, index)">{{ option.quesValue }}</div>
                    <div v-html="option.quesOption" class="option-list"></div>
                </div>
            </div>
            <!-- 解析 -->
            <div class="question-analysis-preview-box" v-show="showAnalysis">
                <div class="question-analysis-preview">
                    <div class="positiveSolution"></div>
                    <span class="title-desc-preview">【解析】</span>
                    <div class="question-analysis-content-preview" v-html="question.analysis"></div>
                </div>
                <!-- 考核点 -->
                <div class="question-knowledge-point-preview">
                    <span class="title-desc-preview">【考核点】</span>
                    <div class="question-analysis-content-preview" v-html="question.examinePoint"></div>
                </div>
            </div>
            <div class="button-box-preview">
                <Button v-if="buttonType == 1" type="primary" @click="sumbitAnswer">提交</Button>
                <Button v-else type="primary" @click="questionModelCancel">关闭</Button>
            </div>
        </Modal>
        <Modal v-model="alertModal" class="alert-modal" title="提示" footer-hide :closable="false" :mask-closable="false" @on-visible-change="colseAlertModal">
            <Alert type="error" show-icon >
                    <Icon type="md-sad" slot="icon" size="35" color="red" />
                    <template slot="desc">
                        学员您好，当前系统已经停止计时，为了确认您是否在计算机面前，特此弹出对话框询问，如有带来不便，请您谅解！
                    </template>
                </Alert>
            <div class="button-box-preview">
                <Button class="btn" type="primary" @click="move()">确定</Button>
            </div>
        </Modal>
        <!-- 人脸识别弹出层 -->
        <modal v-model="signinVisible" footer-hide :mask-closable="false" :closable="false" @on-visible-change="changeFaceModel">
            <FaceSignin v-if="signinVisible" :clientConfig="clientConfig" @on-complete="signinVisible = false"/>
        </modal>
        <!-- 滑块验证弹出层 -->
        <modal v-model="slideVisible" title="滑块验证" footer-hide :mask-closable="false" :closable="false" @on-visible-change="changeSlideModel">
            <SlideVerify v-if="slideVisible&&clientConfig.slideVerify===1" :clientConfig="clientConfig" @on-complete="slideVisible = false" />
            <SlideHeBeiVerify v-if="slideVisible&&clientConfig.slideVerify===2" :clientConfig="clientConfig" @on-complete="slideVisible = false" />
        </modal>
        <SlideBeiJingVerify v-if="clientConfig&&clientConfig.slideVerify===3" :clientConfig="clientConfig" @on-pause="pause" @on-complete="complete" />
        <!-- 自动抓拍人脸识别 -->
        <TakeFaceManual v-if="takeFaceVisible" :clientConfig="clientConfig" @on-complete="takeFaceVisible = false" />
        <Modal
            v-model="takeFaceModal"
            title="人脸抓拍提示"
            :closable="false"
            :mask-closable="false"
            @on-ok="asyncOK">
            <p>学习过程中，会进行至少2次人脸抓拍，确保本人学习，若发现不符则会停止学习！</p>
            <div slot="footer">
                <Button type="primary" @click="asyncOK">确定</Button>
                <!-- 根据条件决定是否渲染取消按钮 -->
                <!-- <Button v-if="showCancelButton" @click="handleCancel">取消</Button> -->
            </div>
        </Modal>
        <Split v-model="split1">
            <div slot="left" class="split-player">
                <!-- 视频播放时 -->
                <div class="player-wrapper">
                    <span class="tag-name" v-html="tagName"></span>
                    <div class="prism-player" id="prism-player"></div>
                    <div class="proogress-x">
                        <div class="progress">
                            <div class="played" :style="'width:' + currentTime + '%'"></div>
                            <div class="cursor" :style="cursorStyle">
                                <img src="/static/img/player/dragcursor.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div v-show="!playedVideoId" class="init-status">请点击章节进行学习</div>
                </div>
            </div>
            <div slot="right" class="split-courseware">
                <!-- 课件 -->
                <div class="courseware">
                    <!-- 课件名字 -->
                    <div class="name">{{ courseware.name }}({{courseware.duration | formatTime}}{{courseware.duration | learnScale(courseware.cwSumTime)}})</div>

                    <!-- 课件章节 -->
                    <div class="chapters">
                        <CoursewarePlayVideoChapter v-for="chapter in courseware.chapters" :chapter="chapter" :key="chapter.id" @on-chapter="play"/>
                    </div>
                </div>
            </div>
        </Split>
    </div>
</template>

<script>

import CoursewarePlayVideoChapter from '@/components/play/CoursewarePlayVideoChapter';
import FaceSignin from '@/components/FaceSignin';
import TakeFaceManual from '@/components/TakeFaceManual';
import SlideVerify from '@/components/SlideVerify';
import SlideHeBeiVerify from '@/components/SlideHeBeiVerify';
import SlideBeiJingVerify from '@/components/SlideBeiJingVerify';


export default {
    components: { CoursewarePlayVideoChapter, FaceSignin, TakeFaceManual, SlideVerify, SlideHeBeiVerify, SlideBeiJingVerify },
    data () {
        return {
            alertModal            : false,                // 鼠标不操作提醒对话框
            questionVideoModal    : false,                // 弹题弹窗
            warningTime           : 15 * 60 * 1000,       // 鼠标不操作提醒时间
            courseware            : { name:'课件名称001' },   // 课件
            tagName               : '',
            currentTime           : 0,                    // 当前播放时间
            playedVideoId         : '',
            learnRecord           : {},                   // 听课记录
            question              : {},                   // 弹题对象
            showAnalysis          : false,                // 解析
            buttonType            : 1,                    // 按钮类型 1提交
            questions             : [],                   // 弹题列表
            questionsOpen         : [],                   // 弹题列表
            lectures              : [],                   // 讲义列表
            catalogKnowledgePoints: [],                   // 知识点列表
            listenTime        : 0,           // 听课时长(秒)
            lastTime          : 0,           // 继续播放时间
            timer             : {},          // 获取当前时间
            syncTime          : SYNV_TIME,   // 保存听课记录间隔, 间隔多少秒保存一次听课记录
            recordInterval    : null,        // 时钟定时任务
            mapChapters       : {},          // 章节目录 map 保存在 store
            continuous        : true,                 // 是否连续 默认是
            playVideos        : [],                   // 自动播放章节视频列表
            player            : null,
            playedVideoChapter: {},
            signinVisible     : false,       // 人脸签到 开关
            faceSigninConfig  : {},          // 人脸识别配置, 是否可跳过, 最大认证次数等, 根据配置进行设置
            faceSiginInterval : null,        // 人脸认证定时任务
            split1            : 0.77,
            takeFaceVisible   : false,       // 自动抓拍人脸开关
            takeFaceModal     : false,       // 抓拍前确认
            slideVisible      : false,       // 滑块验证
        };
    },
    created() {
        // let uId = '852013';
        // this.token = 'eyJhcHBJZCI6IkRlZmF1bHRfSUQiLCJjYXRhbG9nSWQiOiI2MDI3MzM4NDU1OTAwNDg3NjgiLCJjbGllbnRDb2RlIjoiMTIzNDU2IiwiY291cnNld2FyZUNvZGUiOiJjZXNoaTAwMSIsImV4cGlyZWRBdCI6IjE2NTA5NjIzNzIzMDIiLCJzaWduZWRBdCI6IjE2MjkzNjIzNzIzMDMiLCJ1c2VySWQiOiIxMTEyMjIzMzMifQ**.401ee3610104919dff32456c13f63952';
        // 获取 token
        let uId = this.$route.query.uid;
        this.token = Utils.getCookie(uId);
        var _this = this;
        document.onkeydown = function(e) {
            let key = window.event.keyCode;
            if (key == 32 && _window.player.getStatus() != 'pause') {
                _window.player.pause();
            } else if (key == 32) {
                _window.player.play();
            }
        };
    },
    filters: {
        // 已学比例
        learnScale(mediaDuration, sumTime) {
            if (!sumTime || !mediaDuration || mediaDuration === 0) return '';
            // 计算已学比例
            const scale = (sumTime/mediaDuration) * 100;

            // 已学比例超过 100% 那么展示 100%, 否则展示实际比例保留一位有效数字
            if (scale >= 100) { return '/ 已学 100%'; }
            return '/ 已学 '+ Math.round(scale) +' %';
        }
    },
    computed: {
        // 进度条上的按钮
        cursorStyle() {
            if ((this.currentPlayTime - 0.99)> 99) {
                return { right :0 };
            }
            return {
                right: 'auto',
                left: this.currentPlayTime - 0.9 + '%'
            };
        },
        // 题型
        baseTypeLabel() {
            for (let type of QuesstionType) {
                if (this.question.questionType == type.value) {
                    return type.label;
                }
            }
            return '';
        },
        // 展示课件名称
        showName() {
            var courseName = this.clientConfig.courseName;
            if (courseName == 'undefined' || courseName == null || courseName == '') {
                // 修改页面标题
                document.title = this.name;
                return this.name;
            }
            // 修改页面标题
            document.title = courseName;
            return courseName;
        },
        // 当前播放的设置
        clientConfig() {
            return this.courseware.clientParam;
        },
        // 过程中是否需要人脸识别
        isFaceSignin() {
            return this.clientConfig.faceInterval && this.clientConfig.faceInterval != 0;
        },
        // 开始是否需要人脸识别
        isBeforeFaceSignin() {
            return this.clientConfig.faceType && this.clientConfig.faceType === 1;
        },
        // 开始是否需要 人脸抓拍
        isBeforeTakeFace() {
            return this.clientConfig.faceType && this.clientConfig.faceType === 3 && this.clientConfig.isTakeFace===1;
        },
        // 开始是否需要 滑块验证
        isBeforeSlideVerify() {
            return this.clientConfig && (this.clientConfig.slideVerify===1||this.clientConfig.slideVerify===2);
        },
    },
    mounted() {
        // window.player = this.createPlayer();
        // 初始化播放数据
        this.initPlay();
        this.$Message.config({
            top: 250,
            duration: 2
        });
    },
    methods: {
        // 将时间秒转为时分秒格式
        initTime(time) {
            return Utils.getTime(time);
        },
        // 鼠标停留
        stopRoll() {
            var self = this;
            self.timer = setTimeout(function() {
                self.alertModal = true;
            }, self.warningTime);
        },
        // 鼠标移动
        move() {
            clearTimeout(this.timer);
            if (this.alertModal) this.alertModal= false;
            if (this.warningTime!==0) {
                this.stopRoll();
            }
        },
        pause() {
            if (window.player)window.player.pause();
        },
        complete() {
            // 关闭时进行播放, 当有 face 弹窗时不播放
            if (!this.faceInfoModal) window.player.play();
        },
        // 当 alertModal 弹窗变化时
        colseAlertModal(value) {
            if (value) {
                if (window.player.getStatus() != 'pause') {
                    window.player.pause();
                }
                clearTimeout(this.timer);
            }
        },
        // 弹题弹窗点击取消
        questionModelCancel() {
            this.questionVideoModal = false;
            this.$refs.modal.close();
        },
        // 弹题弹窗 变化
        colseModal(value) {
            if (!value) {
                // 关闭时进行播放, 当有 face 弹窗时不播放
                if (!this.faceInfoModal) window.player.play();
                this.buttonType = 1;
                this.showAnalysis = false;
            }
        },
        // 抓拍人脸 提示
        asyncOK() {
            // 开始人脸抓拍 确认
            this.takeFaceVisible = true;
            // 关闭弹窗提示
            this.takeFaceModal = false;
            // 需要播放
            this.play({ chapterId: this.playedVideoChapter.id, lastTime: this.playedVideoChapter.lastTime, changeChatper: false });
        },
        // 启动人脸认证签到定时任务
        startFaceSignin() {
            if (window.player) {
                window.player.play();
            }
            // 清除人脸识别定时任务
            if (this.faceSiginInterval) clearInterval(this.faceSiginInterval);
            // 启动人脸认证定时任务
            this.faceSiginInterval = setInterval(() => {
                // 开始人脸认证并识别
                this.signinVisible = true;

                // 人脸识别配置信息
                this.clientConfig.faceSignInScene = FACE_SIGNIN_SCENE.IN_LEARN_COURSEWARE;
                if (window.player) {
                    window.player.pause();
                }
            }, this.clientConfig.faceInterval * 60 * 1000);
        },
        // 人脸识别弹框变化时
        changeFaceModel (value) {
            if (value) {
                // 暂停播放器
                if (window.player) {
                    window.player.pause();
                }
                // 清除人脸识别定时任务
                if (this.faceSiginInterval) clearInterval(this.faceSiginInterval);
            } else {
                // 是否人脸识别签到
                if (this.isFaceSignin) {
                    // 启动人脸识别定时任务
                    this.startFaceSignin();
                }
                // 需要播放
                this.play({ chapterId: this.playedVideoChapter.id, lastTime: this.playedVideoChapter.lastTime, changeChatper: false });
            }
        },
        // 滑动弹窗变化时
        changeSlideModel (value) {
            if (value) {
                // 暂停播放器
                if (window.player) {
                    window.player.pause();
                }
            } else {
                // 需要播放
                this.play({ chapterId: this.playedVideoChapter.id, lastTime: this.playedVideoChapter.lastTime, changeChatper: false });
            }
        },
        // 标记选项为正确的或者错误的
        chooiceAnswer(question, optionIndex) {
            if (this.readOnly) { return; }
            this.$QuestionUtils.chooiceAnswer(question, optionIndex);
        },
        // 弹题答案提交
        sumbitAnswer() {
            // 过滤学生选择的答案
            let checkList = this.question.optionList.filter(x => x.checked == true);
            if (checkList.length > 0) {
                this.buttonType = 2;
                this.showAnalysis = true;
                // 验证答案是否正确
                let rightAnswers = checkList.filter(x => this.rightAnswers.includes(x.quesValue));
                this.learnRecord.questionId = this.question.questionId;
                this.learnRecord.examinePoint = this.question.examinePoint;
                this.learnRecord.isPass = false;
                // 验证是否正确, 选择的数量和正确的数量, 和选对的数量要一致!
                if (rightAnswers.length == this.rightAnswers.length && checkList.length == this.rightAnswers.length) {
                    this.learnRecord.isPass = true;
                }
                this.saveRecordTime();
            } else {
                this.$Message.warning('请作答！');
            }
        },
        // 初始化播放数据
        initPlay() {
            this.mapChapters = new Map();
            // 获取用户 ID 班级 ID 课件 ID
            this.$ClientDao.getCourseware(this.token).then((courseware) => {
                this.courseware = courseware;
                this.getCourseWare().then((mapChapters) => {
                    // console.log('mapChapters', mapChapters);
                    this.mapChapters = mapChapters;
                    // console.log('this.mapChapters', this.mapChapters.size);
                    if (this.mapChapters.size > 0) {
                        this.$store.commit('setMapChapters', this.mapChapters);
                        // console.log('mapChapters', this.mapChapters);
                    }
                    // 标识名称
                    if (this.courseware.clientParam.tagName) this.tagName = this.courseware.clientParam.tagName;
                    // console.log('courseware', JSON.stringify(this.courseware));
                    // 存在指定章节, 则播放指定的章节, 否则默认第一个
                    if (this.courseware.clientParam.catalogId) this.playedVideoChapter = this.mapChapters.get(this.courseware.clientParam.catalogId);
                    // console.log('this.playedVideoChapter', this.playedVideoChapter);
                    if (this.courseware.clientParam.warningTime===0) {
                        this.warningTime=0;
                        this.move();
                    }
                    // 课件学习开始前是否需要人脸识别, 需要则进行人脸识别, 否则继续
                    if (this.isBeforeFaceSignin) {
                        // 开始人脸认证并识别
                        this.signinVisible = true;
                        // 人脸识别配置信息
                        this.clientConfig.faceSignInScene = FACE_SIGNIN_SCENE.BEFORE_LEARN_COURSEWARE;
                        if (window.player) {
                            window.player.pause();
                        }
                    } else if (this.isBeforeTakeFace) {
                        this.takeFaceModal=true;
                        // 人脸识别配置信息
                        this.clientConfig.faceSignInScene = FACE_SIGNIN_SCENE.IN_LEARN_COURSEWARE;
                        if (window.player) {
                            window.player.pause();
                        }
                    } else if (this.isBeforeSlideVerify) {
                        console.log('this.slideVisible'+new Date(), this.slideVisible);
                        // 滑块验证信息
                        setTimeout(() => {
                            this.slideVisible=true;
                            console.log('this.slideVisible'+new Date(), this.slideVisible);
                        }, 1*60*1000);
                        this.clientConfig.faceSignInScene = FACE_SIGNIN_SCENE.BEFORE_LEARN_COURSEWARE;
                        if (window.player) {
                            window.player.pause();
                        }
                    }  else {
                        this.play({ chapterId: this.playedVideoChapter.id, lastTime: this.playedVideoChapter.lastTime, changeChatper: false });
                        // 是否需要过程中人脸签到, 需要则启动定时任务
                        if (this.isFaceSignin) {
                            this.startFaceSignin();
                        }
                    }
                });
            });
        },
        getCourseWare() {
            return new  Promise((res, rej) => {
                // 递归设置章节听课记录
                this.courseware.chapters.forEach(chapter => {
                    this.setLearnRecord(chapter);
                });
                res(this.mapChapters);
            });
        },
        // 章节设置累计听课记录
        setLearnRecord(chapter) {
            // 判断是否存在子章节, 若存在递归
            if (chapter.children && chapter.children.length) {
                chapter.children.forEach(childrenChapter => {
                    this.setLearnRecord(childrenChapter);
                });
            }
            // 设置视频章节 Map
            if (chapter.isMedia === 1) {
                // console.log(chapter.id);
                // 设置默认第一个视频播放
                // if (Object.keys(this.mapChapters).length === 0) this.playedVideoChapter = chapter;
                if (!this.playedVideoChapter || !this.playedVideoChapter.id) this.playedVideoChapter = chapter;
                this.mapChapters.set(chapter.id, chapter);
                // 设置播放列表
                this.playVideos.push(chapter);
            }
        },
        // 创建播放器
        createPlayer(aliVideoId, playAuth, cover, lastime) {
            // console.log('createPlayer方法被调用，准备创建播放器');
            // console.log('参数:', { aliVideoId, playAuth, cover, lastime });

            try {
                // console.log('开始实例化Aliplayer...');
                window.player= new Aliplayer({
                    id         : 'prism-player',
                    vid        : aliVideoId,
                    playauth   : playAuth,
                    autoplay   : true,
                    playsinline: false,
                    useH5Prism : false,
                    width      : '100%',
                    height     : '100%',
                    language   : 'zh-cn',
                    controlBarVisibility: 'always',
                    format: 'm3u8',
                    showBarTime: 2000,
                    skinLayout: [
                        { name: 'bigPlayButton', align: 'blabs', x: 30, y: 80 },
                        {
                            name: 'controlBar', align: 'blabs', x: 0, y: 0,
                            children: [
                                { name: 'progress', align: 'blabs', x: 0, y: 44 }, // 进度条
                                { name: 'playButton', align: 'tl', x: 15, y: 12 }, // 播放按钮
                                { name: 'timeDisplay', align: 'tl', x: 10, y: 7 }, // 时长
                                { name: 'fullScreenButton', align: 'tr', x: 10, y: 12 }, // 全屏
                                // { name:'subtitle', align:'tr', x:15, y:12 }, // 字幕
                                { name:'setting', align:'tr', x:5, y:12 },
                                { name: 'volume', align: 'tr', x: 5, y: 10 } // 音量
                            ]
                        }
                    ]
                }, function(player) {
                    // console.log('播放器实例化回调函数被调用！');
                    // console.log('回调函数中的player对象:', player);
                    // console.log('播放器创建成功');
                });
                let isPoint = false;

                // 初始播放位置
                if (lastime && lastime > 0 && !this.signinVisible) {
                    let filterList = this.questionsOpen.filter(q => q.mediaTime == lastime);
                    if (filterList.length > 0) {
                        lastime -= 5;
                    }
                    window.player.seek(lastime);
                }
                // 自定义进度条
                let nodrag = document.getElementsByClassName('proogress-x');
                // alipayer 进度条
                let drag = document.getElementsByClassName('prism-progress');

                // 不允许拖拽时隐藏 aliplayer 进度条
                if (this.clientConfig.isDrag === 1) {
                    nodrag[0].style.display = 'block';
                    drag[0].style.display = 'none';
                    // 去除倍速
                    var speed = document.getElementsByClassName('prism-setting-speed');
                    speed[0].remove();
                }
                const self = this;
                // 播放事件: 点击暂停后再开始
                window.player.on('play', (e) => {
                    if (!isPoint) {
                        if (self.timers) clearInterval(self.timers);
                        isPoint = true;
                        // 弹题
                        self.getTimes();
                    }
                    // 定时任务存在则清除
                    if (self.recordInterval) {
                        clearInterval(self.recordInterval);
                    }
                    // 播放中启动记录听课时长任务
                    self.recordInterval = setInterval(self.recordTime, 1000);
                });
                // 视频加载完成后开始回传记录
                window.player.on('playing', function(e) {
                    // 是否展示弹题点
                    if (self.clientConfig.hintPoint == 1) {
                        // 加载弹题点
                        self.createQuestionPointAliyun();
                    }
                });
                // 暂停事件: 暂停时进行
                window.player.on('pause', (e) => {
                    // console.log('pause');
                    // 清除定时任务
                    clearInterval(self.recordInterval);
                    // 保存听课时长
                    self.saveRecordTime();
                });
                // 播放中
                window.player.on('timeupdate', (e) => {
                    self.currentTime = (window.player.getCurrentTime() / window.player.getDuration()) * 100;
                    if (self.currentTime > 100) {
                        self.currentTime = 100;
                    }
                });
                // 拖拽进度条前回传听课记录
                window.player.on('startSeek', function(e) {
                    // drag 拖动参数等于 1 不可拖动进度条
                    if (self.clientConfig.isDrag === 1) {
                        // self.startSeekTime = player.getCurrentTime();
                    } else {
                        // 将当前视频的所有题的弹题状态变为true;
                        self.questionsOpen.forEach(q => q.flag = true);
                        // dragInsertLearnRecord(parseInt(e.paramData));
                    }
                });
                // 拖拽完成事件
                window.player.on('completeSeek', (e) => {
                });
                // 课件播放完毕
                window.player.on('ended', (e) => {
                    // 定时任务存在则清除
                    if (self.recordInterval) {
                        clearInterval(self.recordInterval);
                    }
                    // 保存听课时长
                    self.saveRecordTime();
                    // 是否连续播放
                    self.chainBroadcast();
                });
                // 课件播放出错
                window.player.on('error', (e) => {
                    // 定时任务存在则清除
                    if (self.recordInterval) {
                        clearInterval(self.recordInterval);
                    }
                });
                // 点击弹题点显示题目弹窗
                $(document).on('click', '.point', (event) => {
                    // 允许拖拽, 才可点击弹题点
                    if (self.clientConfig.isDrag != 1) {
                        // 将题目的弹题状态置位true
                        self.questionsOpen.forEach(q => q.flag = true);
                        var duration = $('video').get(0).duration;
                        var thisTime = $(event.target).attr('data-time')/100*duration;
                        // 调整进度
                        window.player.seek(Math.round(thisTime));
                        self.questionVideoModal = true;
                        window.player.pause();
                    }
                });
                if (self.clientConfig.hintPoint === 1) {
                    // 滑过进度条，调整追加元素样式
                    $('.progress').hover(function() {
                        $('.importantb').css({ 'height':'10px', 'top':'-6px' });
                        $('.point').css({ 'width':'15px', 'height':'15px', 'top':'-5px' });
                    }, function() {
                        $('.importantb').css({ 'height':'4px', 'top':'0px' });
                        $('.point').css({ 'width':'10px', 'height':'10px', 'top':'-3px' });
                    });
                } else {
                    // 滑过进度条，调整追加元素样式
                    $('.prism-progress').hover(function() {
                        $('.importantb').css({ 'height':'10px', 'top':'-6px' });
                        $('.point').css({ 'width':'15px', 'height':'15px', 'top':'-8px' });
                    }, function() {
                        $('.importantb').css({ 'height':'4px', 'top':'0px' });
                        $('.point').css({ 'width':'10px', 'height':'10px', 'top':'-3px' });
                    });
                }
                // 点击讲义列表
                $(document).on('click', '.handout .handout-list li', (event) => {
                    var minute = $(event.target).parent().find('.title').find('.minute');
                    var second = $(event.target).parent().find('.title').find('.second');
                    minuteTime=parseInt(minute.html().split(':')[0])*3600+parseInt(minute.html().split(':')[1])*60+parseInt(minute.html().split(':')[2]);
                    secondTime=parseInt(second.html().split(':')[0])*3600+parseInt(second.html().split(':')[1])*60+parseInt(second.html().split(':')[2]);
                    $('.handout .handout-list li').removeClass('active');
                    $(event.target).parents('li').addClass('active');
                    // 调整进度
                    window.player.seek(minuteTime);
                });
                $('.prism-controlbar').append('<a download class="file-download"></a>');
                $('.file-download').attr('href', self.uploadedFileUrl);
            } catch (error) {
                console.error('实例化Aliplayer时发生异常:', error);
                throw error;
            }
        },
        // 创建弹题点
        createQuestionPointAliyun() {
            if (!self.answer) return;
            // 知识点
            // console.log('createQuestionPointAliyun');
            var pointsTime = self.pointsTime?self.pointsTime.split(','):[];
            // 获取视频时长
            var duration = $('video').get(0).duration;
            for (var j =0; j <pointsTime.length-1; j++) {
                var importantbStart = pointsTime[j].split('+')[0]/ duration*100;
                // 知识点结束距离左边距离
                var importantbEnd = pointsTime[j].split('+')[1] / duration*100;
                var importantbWidth = importantbEnd - importantbStart;
                if (self.clientConfig.isDrag == 1) {
                    $('.progress').append(`<div class="importantb" style="left: ${importantbStart}%;width:${importantbWidth}%"></div>`);
                } else {
                    $('.prism-controlbar').append(`<div class="importantb" style="left: ${importantbStart}%;width:${importantbWidth}%"></div>`);
                }
            }
            // console.log('self.answer', self.answer);
            for (var m=0; m<self.answer.length; m++) {
                // 创建答题点
                var left = self.answer[m] / duration*100;
                if (self.clientConfig.isDrag == 1) {
                    $('.progress').append(`<div class="point" style="left: ${left}%" data-time="${left}"></div>`);
                } else {
                    $('.prism-controlbar').append(`<div class="point" style="left: ${left}%" data-time="${left}"></div>`);
                }
            }
        },
        getTimes() {
            // console.log('getTimes');
            $('.handout .handout-list li').removeClass('active');
            $('.knowledge-points .knowledge-points-list li').removeClass('actives');
            var currentTime = parseInt(window.player.getCurrentTime());
            const self = this;
            this.timers = setTimeout(self.getTimes, 1000);
            //讲义联动
            for (var m=0; m<this.lectures.length; m++) {
                if (this.lectures[m].startTime<=currentTime && this.lectures[m].endTime>=currentTime) {
                    $('.handout .handout-list li').removeClass('active');
                    $('.handout .handout-list li').eq(m).addClass('active');
                }
            }
            //知识点联动
            for (var s=0; s<this.catalogKnowledgePoints.length; s++) {
                if (this.catalogKnowledgePoints[s].startTime<=currentTime && this.catalogKnowledgePoints[s].endTime>=currentTime) {
                    $('.knowledge-points .knowledge-points-list li').removeClass('actives');
                    $('.knowledge-points .knowledge-points-list li').eq(s).addClass('actives');
                }
            }
            for (var b=0; b<this.questionsOpen.length; b++) {
                var positiveSolution='';
                if (this.questionsOpen[b].flag && this.questionsOpen[b].mediaTime == currentTime) {
                    // 将题目的选项选中状态去掉
                    this.rightAnswers = [];
                    for (var c= 0; c<this.questionsOpen[b].optionList.length; c++) {
                        if (this.questionsOpen[b].optionList[c].correct==true) {
                            positiveSolution+=this.questionsOpen[b].optionList[c].quesValue+' ';
                            this.rightAnswers.push(this.questionsOpen[b].optionList[c].quesValue);
                        }
                    }
                    $('.positiveSolution').html('【答案】'+positiveSolution);
                    for (let options of this.questionsOpen[b].optionList) {
                        this.$set(options, 'checked', false);
                    }
                    this.question = this.questionsOpen[b];
                    this.questionVideoModal = true;
                    this.questionsOpen[b].flag = false;
                    window.player.pause();
                    this.cancelFull();
                }
            }
        },
        // 连续播放
        chainBroadcast() {
            if (this.continuous) {
                // 查找同父节点的章节根据序号排序
                let index = this.playVideos.findIndex(x => x.id == this.playedVideoId);
                let nextChatper = this.playVideos[index + 1];
                if (index > -1 && nextChatper) {
                // this.mapChapters.get(nextChatper.id);
                // this.changeMediaUrl(node);
                    let chapterId = nextChatper.id;
                    let _this = this;
                    setTimeout(() => {
                        _this.play({ chapterId, lastTime:0, nextChatper:true });
                        _this.$store.commit('setPlayVideoChapterId', chapterId);
                        _this.$store.commit('setPlayVideoChapter', nextChatper);
                    }, 1000);
                }
            }
        },
        // 开始播放 (注: chapterId 为章节 ID ，media.mediaSource 为阿里云视频 ID, lastTime 继续播放时间)
        play({ chapterId, lastTime, changeChatper }) {
            // console.log('play方法被调用');
            // console.log('播放参数:', { chapterId, lastTime, changeChatper });
            // chapterId 为空或者是正在播放的章节，则返回
            if (!chapterId || this.playedVideoId === chapterId) {
                return;
            }
            if (changeChatper) {
                this.saveRecordTime();
            } else {
                // 设置当前播放章节 ID
                this.$store.commit('setPlayVideoChapterId', chapterId);
                this.$store.commit('setPlayVideoChapter', this.playedVideoChapter);
            }
            let media;
            // 获取章节信息
            this.$ClientDao.getChatper(chapterId, this.token).then((catalog) => {
                // console.log('getChatper catalog', catalog);
                this.playedVideoId = catalog.id;
                this.playedVideoChapter = this.mapChapters.get(catalog.id);
                media = catalog.media;
                this.learnRecord = {
                    clientCode: this.courseware.clientParam.clientCode,
                    courseCode: this.courseware.clientParam.courseCode,
                    coursewareCode: this.courseware.code,
                    catalogId: catalog.id,
                    userId: this.courseware.clientParam.userId,
                    userName: this.courseware.clientParam.userName,
                };
                // 获取讲义
                if (catalog.lectures.length > 0) {
                    this.lectures.push(...catalog.lectures.sort(this.compare('startTime')));
                }
                // 获取知识点
                if (catalog.catalogKnowledgePoints.length > 0) {
                    this.catalogKnowledgePoints.push(...catalog.catalogKnowledgePoints.sort(this.compare('startTime')));
                    var pointsTime='';
                    for (var i=0; i<this.catalogKnowledgePoints.length; i++) {
                        pointsTime+= this.catalogKnowledgePoints[i].startTime+'+'+this.catalogKnowledgePoints[i].endTime+',';
                    }
                    this.pointsTime=pointsTime;
                    // console.log('this.pointsTime', this.pointsTime);
                }
                // 获取弹题
                if (catalog.questions.length > 0) {
                    this.questions.push(...catalog.questions);
                    this.answer = this.questions.map(x => x.mediaTime);
                    for (let question of this.questions) {
                        this.$set(question, 'flag', true);
                        this.questionsOpen.push(question);
                    }
                } else {
                    this.answer = [];
                }
                // 不存在听课记录则使用默认的
                if (catalog.learnRecord) lastTime = catalog.learnRecord.lastime;
                // console.log('准备创建播放器，调用createPlayer方法');
                this.stop();
                // console.log('stop方法执行完成，开始调用createPlayer');
                try {
                    this.createPlayer(media.mediaSource, media.playAuth, media.mediaPrevPicUrl, lastTime);
                    // console.log('createPlayer调用完成，player赋值成功:', window.player);
                } catch (error) {
                    console.error('createPlayer调用失败:', error);
                }
            }).finally(() => {

            });
        },
        // 计时任务
        recordTime() {
            this.listenTime += 1;
            // console.log('this.listenTime', this.listenTime);
            // 保存听课记录间隔, 间隔多少秒保存一次听课记录
            if (this.listenTime >= this.syncTime) {
                // console.log('listenTime==', this.listenTime);
                this.saveRecordTime();
            }
        },
        // 保存听课记录
        saveRecordTime() {
            // 当有保存时长记录的调用, 则禁止调用, 直接 return
            if (this.saveRecording) return;
            this.saveRecording = true;
            // 获取当前播放时间点
            if (window.player) this.learnRecord.lastTime = window.player.getCurrentTime().toFixed(0);
            // 本次累计时长
            this.learnRecord.listenTime = this.listenTime;
            // this.learnRecord.listenTime = 10;
            // console.log('this.learnRecord.listenTime', this.learnRecord.listenTime);
            if (!this.learnRecord.clientCode||!this.learnRecord.coursewareCode) {
                // console.log('this.learnRecord', this.learnRecord);
                this.saveRecording = false;
                return;
            }
            // 保存
            this.$ClientDao.saveRecord(this.token, this.learnRecord).then((result) => {
                if (result) {
                    // 保存完成后清空本次时长
                    this.listenTime = 0;
                    // 重置弹题数据
                    this.learnRecord.questionId = 0;
                    this.learnRecord.examinePoint = '';
                    this.learnRecord.isPass = null;
                    // 获取章节 map
                    let chapter = this.mapChapters.get(this.learnRecord.catalogId);

                    // 更新 store 中章节 map
                    chapter.lastTime = this.learnRecord.lastTime;
                    const sumTime = Number(chapter.sumTime) + Number(this.learnRecord.listenTime);
                    chapter.sumTime = sumTime;
                    this.$store.commit('setPlayVideoChapter', chapter);
                    this.mapChapters.set(chapter.id, chapter);
                    this.$store.commit('setMapChapters', this.mapChapters);
                } else {
                    player.pause();
                    // this.errorRouter();
                }
                this.saveRecording = false;
            });
        },
        // 停止播放
        stop() {
            clearInterval(this.recordInterval);
            // 停止播放，并销毁播放器
            if (window.player) {
                // window.player.pause();
                window.player.dispose();
                document.getElementById('prism-player').empty;
                // window.player = null;
            }
        },
        // 退出全屏
        cancelFull() {
            if (window.player && window.player.fullscreenService.getIsFullScreen()) window.player.fullscreenService.cancelFullScreen();
        },
        // error 跳转
        errorRouter(msg) {
            // let errorMsg = '视频浏览权限已失效！';
            // 移除组件
            this.clearTimeOuts();
            this.faceRecognition = false;
            this.videoRecording = false;
            this.validateCode = false;
            // 跳转错误页
            this.$router.push({
                name: 'player-error',
                params: {
                    error: msg
                }
            });
        },
    },
};

</script>

<style lang="scss">
.student-learn {
    width   : 100%;
    height  : 100%;
    position: relative;
    overflow: hidden;
    .split-player {
        width: 100%;
    }
    .split-courseware {
        width: 100%;
    }
    .ivu-split-trigger-vertical {
        border-top: none;
        cursor: col-resize;
        height: 0;
    }
    .ivu-split-trigger-bar-con.vertical {
        background-color: #ffffff;
    }
    .player-wrapper {
        width: 100%;
        position: absolute;
        top   : 0;
        left  : 0;
        right : 300px;
        bottom: 0;
        .proogress-x {
            display: none;
            position: absolute;
            bottom: 40px !important;
            width: 100%;
            .progress{
                position: absolute;
                top: 0;
                width: 100%;
                height: 4px;
                background: rgba(195,197,198,.5);
                box-shadow: inset 1px 1px 1px 0 rgba(0,0,0,.06);
                position: relative;
                cursor: pointer;
                .played{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 0;
                    height: 100%;
                    background-color: #00c1de;
                }
                .cursor {
                    position: absolute;
                    border-radius: 8px;
                    top: -5px;
                    right: 0;
                    width: 16px;
                    height: 16px;
                    overflow: hidden;
                    box-sizing: content-box;
                    background: url('/static/img/player/dragcursorhover.png') center;
                    background-repeat: no-repeat;
                    display: none;
                    img {
                        width: 14px;
                        height: 14px;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        -ms-transform: translate(-50%,-50%);
                        transform: translate(-50%,-50%);
                        z-index: 1;
                    }
                }
                &:hover {
                    height: 6px;
                    transition: height .3s;
                    .cursor {
                        display: block;
                    }
                }
            }
        }
        .tag-name{
            position: fixed;
            top: 10px;
            left: 10px;
            font-size: 20px;
            z-index: 1;
            color: #00c1de;
        }
    }

    .courseware {
        position: absolute;
        top   : 0;
        right : 0;
        bottom: 0;
        width: 100%;
    }

    #prism-player {
        overflow: hidden;
        .prism-setting-cc {
            display: none;
        }
        .prism-setting-audio {
            display: none;
        }
        .prism-setting-btn {
            margin-right: 5px;
        }
        .prism-controlbar{
            bottom: 10px!important;
            z-index: 12;
        }
        .point {
            position: absolute;
            top: -3px;
            width: 10px;
            height: 10px;
            border: 1px solid blue;
            border-radius: 50%;
            background: red;
            z-index: 100000;
            cursor:pointer;
        }
        .points span{
                display: inline-block;
                padding: 5px 10px;
        }
        .importantb{
            position: absolute;
            top: 0px;
            height: 4px;
            left: 400px;
            background: red;
            width: 50px;
        }
        .point:hover {
            border: 1px solid white;
            background: orange;
        }
        .prism-controlbar{
            display: block!important;
        }
        .prism-progress-cursor{
            z-index: 5;
        }

        .prism-big-play-btn {
            top : 50% !important;
            left: 50% !important;
            transform: translate(-50%, -50%);
        }
        // 取消
        .prism-cover {
            background-image: url('')!important;
        }
    }

    .player-wrapper .init-status {
        display: inline-block;
        color: #bbb;
        background: #666;
        position: absolute;
        top : 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%);
        font-size: 40px;
        border-radius: 4px;
        box-shadow: 0 0 10px rgba(255, 255, 255, 0.4);
        padding: 10px 20px;
        z-index: 100;
        cursor: default;
    }

    .courseware {
        display: grid;
        grid-template-rows: max-content 1fr;
        background: #26292c;

        > .name {
            height: 40px;
            line-height: 40px;
            width: 100%;
            text-align: center;
            color: #ccc;
            background: #1c1f21;
            font-size: 16px;
            font-weight: bold;
            box-shadow: 0 0 10px rgba(0, 0, 0, .8);
        }

        .chapters {
            padding: 12px 12px 24px 24px;
            overflow: auto;
            flex: 1;
        }
    }
}
// 弹题样式 开始
.question-stem-preview{// 弹题作答提示!
    .pass{
        float: right;
        font-weight: bold;
        font-size: 20px;
        color: green;
    }
    .fail{
        float: right;
        font-weight: bold;
        font-size: 20px;
        color:red;
    }
    padding-bottom: 10px;
}
.options-content-preview{
    .question-option-preview{
        cursor:pointer;
        overflow: hidden;
        padding-left: 14px;
        padding-bottom: 10px;
        .ivu-radio{
            float: left;
            margin-top: 3px;
        }
        .option-content-preview{
            float: left;
            height: 20px;
            line-height: 20px;
        }
    }
    .check-box-group {
        display: block;
        margin-bottom: 10px;
    }
}
.button-box-preview{
        text-align: center;
}
.options-content-preview{
    padding-top: 10px;
}
.question-analysis-preview{
    padding-left: 10px;
}
.question-knowledge-point-preview{
    padding-left: 10px;
}
.question-options {
    flex: 1;

    // 单选题、多选题选项
    .question-option {
        display: flex;
        margin-bottom: $gap;
        &:hover {
            .mark {
                color: white;
                background: $primaryColor;
            }
        }

        // 单选题、多选题选项的标记 A, B, C, D
        .mark {
            // 圆形
            min-width : $optionWidth;
            min-height: $optionWidth;
            max-width : $optionWidth;
            max-height: $optionWidth;
            border-radius: 50%;
            margin-right: $gap;
            @include alignCenter;
            border: 1px solid $separatorColor;
            cursor: pointer;

            // 正确选项
            &.correct {
                color: white;
                background: $primaryColor;
            }
            &:hover {
                color: white;
                background: $primaryColor;
            }
        }
        .option-list {
            line-height: 28px;
        }
    }

    // 判断题
    &.question-optioins-tfng {
        display: flex;

        // 判断题的答案按钮
        .question-optioin-tfng {
            @include alignCenter;
            width: 70px;
            height: $optionWidth - 2;
            border: $optionBorder;
            border-radius: $borderRadius;
            cursor: default;

            // 正确答案按钮
            &.correct {
                color: white;
                background: $primaryColor;
                border-color: $primaryColor;
            }

            // 左边按钮
            &:first-child {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                border-right-width: 0;
                margin-right: 0;
            }

            // 右边按钮
            &:last-child {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                border-left-width: 0;
            }
        }
    }
}

// 弹题样式 结束

.alert-modal {

}
</style>
